import { useQuery } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';
import { AdsMarketResponseType } from '../../types/apiTypes';
//First ha squareside, om man börjar rita ta bort den och skicka in marketPolygon
const useMarket = (
  marketRectangleBounds: any,//google.maps.LatLngBoundsLiteral | null,
  parameters: any,
  coordinates: number[][] | null
) => {
  return useQuery({
    queryKey: ['market', marketRectangleBounds, parameters, coordinates],
    queryFn: async (): Promise<AdsMarketResponseType | null> => {
      if (!parameters) {
        return Promise.resolve(null);
      }

      Object.keys(parameters).forEach((key) => {
        if (parameters[key] === null) {
          delete parameters[key];
        }
      });

      const url = `${import.meta.env.VITE_API_MARKET_SHARE_URL}`;
      const polygon = {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "Polygon",
              coordinates: [coordinates]
            },
            properties: {}
          }
        ]
      }

      if (coordinates) {
        const bodyWithPolygons = {
          ...parameters,
          polygons: polygon
        }
        const { data } = await axiosClient.post<AdsMarketResponseType>(url, bodyWithPolygons);
        return data;
      } else {
        const bodyDefaults = {
          ...parameters,
          ...marketRectangleBounds
        }
        const { data } = await axiosClient.post<AdsMarketResponseType>(url, bodyDefaults);
        return data;
      }
    },
    enabled: !!marketRectangleBounds || !!coordinates,
  });
};

export default useMarket;
